import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Chip, ChipBackgroundColor, ChipIconPosition, ChipSize } from "@amzn/stencil-react-components/chip";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { IconBookmarkFillExtraSmall, IconBookmarkSmall, IconDesktopExtraSmall } from "@amzn/stencil-react-icons";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React from "react";

const NA_STRING = "N/A";

export interface ProductOverviewProps {
  parentItemName: string;
  shortDescription?: string;
  categories: string[];
  os: string[];
  etaDays: number;
  dataClassification?: string;
  securityStatus?: string;
  version?: string;
}

export const ProductOverview: React.FC<ProductOverviewProps> = ({
  parentItemName,
  shortDescription,
  categories,
  os,
  etaDays,
  dataClassification,
  securityStatus,
  version,
}) => {
  return (
    <Col className="pdp-column-center">
      <Row justifyContent="space-between">
        <Row gridGap="S200" alignItems="center" padding={{ top: "S200" }}>
          <Text fontSize="T200" className="product-title" data-testid="product-title">
            {parentItemName}
          </Text>
          <Button
            variant={ButtonVariant.Tertiary}
            icon={<IconBookmarkSmall />}
            onClick={() => {/* Lists not yet wired */}}
            style={{ maxHeight: "40px" }}
            data-testid="bookmark-button"
          />
        </Row>
      </Row>

      {shortDescription && (
        <div className="product-short-details" data-cy="product-short-details">
          <Text fontSize="T100" className="product-description" data-testid="product-short-description">
            {shortDescription}
          </Text>
        </div>
      )}

      <Row gridGap="S200" margin={{ top: "S400", bottom: "S400" }}>
        {categories.map((cat) => (
          <Chip
            icon={<IconBookmarkFillExtraSmall />}
            iconPosition={ChipIconPosition.Leading}
            backgroundColor={ChipBackgroundColor.Blue}
            size={ChipSize.ExtraSmall}
            key={`category-${cat}`}
          >
            {cat}
          </Chip>
        ))}
        {os.map((osItem) => (
          <Chip
            icon={<IconDesktopExtraSmall />}
            iconPosition={ChipIconPosition.Leading}
            backgroundColor={ChipBackgroundColor.Blue}
            size={ChipSize.ExtraSmall}
            key={`os-${osItem}`}
          >
            {osItem}
          </Chip>
        ))}
      </Row>

      <hr />

      {/* Product properties */}
      <Row columnGap={60} gridGap={0} justifyContent="space-between" margin={{ bottom: "S400" }}>
        <Text className="product-property">
          <label data-testid="delivery-time-label">{getString("details.deliveryTimeframe")}</label>
          <br />
          <strong>{etaDays > 0 ? `${etaDays} days` : "Contact support"}</strong>
        </Text>
        <Text className="product-property">
          <label data-testid="data-classification-label">{getString("details.dataClassification")}</label>
          <br />
          <strong>{dataClassification ?? NA_STRING}</strong>
        </Text>
        <Text className="product-property">
          <label data-testid="security-status-label">{getString("details.securityStatus")}</label>
          <br />
          <strong>{securityStatus ?? NA_STRING}</strong>
        </Text>
        <Text className="product-property">
          <label data-testid="version-label">{getString("details.version")}</label>
          <br />
          <strong>{version ?? NA_STRING}</strong>
        </Text>
      </Row>
    </Col>
  );
};
